import React, { useEffect, useState } from 'react'
import TcRACI from './TcRACI'
import Loading from 'src/Common/ui/Loading'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router'
import { typePreviewTransferCondition } from 'src/Entities/TransferEntities'

export default function TransferRaciContainer ({ type, setTransferTableSearchValue }) {
    const [ loading, setLoading ] = useState(false)
    const { formState: { errors }, control } = useForm({})
    const [ matrixOptions, setMatrixOptions ] = useState({
        departmentOptions: [],
        department: null,
        roleOptions: [],
        role: null,
        userOptions: [],
        user: null
    })
    const navigate = useNavigate()
    const queryParams = new URLSearchParams(location.search)

    useEffect(() => {
        queryParams.set('roleId', matrixOptions.role || 0)
        queryParams.set('userId', matrixOptions.user || 0)
        queryParams.set('matrix', !typePreviewTransferCondition(type) ? 1 : 2)
        navigate(`?${queryParams.toString()}`)
    }, [matrixOptions.user])
    return (
        <div className='w-[50%]'>
            <Loading isLoading={loading} setLoading={setLoading}/>
            <TcRACI
                errors={errors}
                control={control}
                loading={loading}
                setLoading={setLoading}
                matrixOptions= {matrixOptions}
                setMatrixOptions={setMatrixOptions}
                setTransferTableSearchValue={setTransferTableSearchValue}
                resetShow={true}
            />

        </div>
    )
}
